export function unwrapApiDataArray<T>(raw: unknown): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (raw != null && typeof raw === "object") {
    const record = raw as Record<string, unknown>;
    if (Array.isArray(record.data)) return record.data as T[];
    if (record.data != null && typeof record.data === "object") {
      const nested = record.data as Record<string, unknown>;
      if (Array.isArray(nested.data)) return nested.data as T[];
      if (Array.isArray(nested.content)) return nested.content as T[];
    }
    if (Array.isArray(record.content)) return record.content as T[];
  }
  return [];
}
